export class UserStatusResetConstants {
   public static readonly NEVER = 0;
   public static readonly UNLIMITED = -1;
}
